"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createRoutesManifest_exports = {};
__export(createRoutesManifest_exports, {
  createRoutesManifest: () => createRoutesManifest
});
module.exports = __toCommonJS(createRoutesManifest_exports);
var import_getRoutes = require("../router/getRoutes");
var import_getServerManifest = require("./getServerManifest");
function createMockModuleWithContext() {
  var map = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var contextModule = function contextModule2(key) {
    return {
      default() {
      }
    };
  };
  Object.defineProperty(contextModule, "keys", {
    value: function value() {
      return map;
    }
  });
  return contextModule;
}
function createRoutesManifest(paths, options) {
  var routeTree = (0, import_getRoutes.getRoutes)(createMockModuleWithContext(paths), {
    ...options,
    preserveApiRoutes: true,
    ignoreRequireErrors: true,
    ignoreEntryPoints: true,
    platform: "web"
  });
  if (!routeTree) {
    throw new Error(`No route tree found in paths: ${JSON.stringify(paths)}`);
  }
  return (0, import_getServerManifest.getServerManifest)(routeTree);
}
//# sourceMappingURL=createRoutesManifest.js.map
